import { useState } from 'react';
import { OtherSettings } from '../../../domain/otherSettings';

export const useOtherSettingsForm = (initialOtherSettings: OtherSettings) => {
    const [otherSettings, setOtherSettings] = useState<OtherSettings>(initialOtherSettings || {
        defaultCurrency: 'EUR',
        startMonth: '1',
        startYear: new Date().getFullYear().toString()
    });

    return {
        otherSettings,
        setOtherSettings: (newOtherSettings: OtherSettings) => setOtherSettings(newOtherSettings),
    }
}
